"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var StarIcon16Light_1 = require("./StarIcon16Light");
var StarIcon16Regular_1 = require("./StarIcon16Regular");
var StarIcon16Solid_1 = require("./StarIcon16Solid");
var StarIcon20Light_1 = require("./StarIcon20Light");
var StarIcon20Regular_1 = require("./StarIcon20Regular");
var StarIcon20Solid_1 = require("./StarIcon20Solid");
var StarIcon24Regular_1 = require("./StarIcon24Regular");
var StarIcon24Solid_1 = require("./StarIcon24Solid");
var StarIcon32Regular_1 = require("./StarIcon32Regular");
var StarIcon64Regular_1 = require("./StarIcon64Regular");
var sizes = {
    16: {
        light: StarIcon16Light_1.StarIcon16Light,
        regular: StarIcon16Regular_1.StarIcon16Regular,
        solid: StarIcon16Solid_1.StarIcon16Solid,
    },
    20: {
        light: StarIcon20Light_1.StarIcon20Light,
        regular: StarIcon20Regular_1.StarIcon20Regular,
        solid: StarIcon20Solid_1.StarIcon20Solid,
    },
    24: {
        regular: StarIcon24Regular_1.StarIcon24Regular,
        solid: StarIcon24Solid_1.StarIcon24Solid,
    },
    32: {
        regular: StarIcon32Regular_1.StarIcon32Regular,
    },
    64: {
        regular: StarIcon64Regular_1.StarIcon64Regular,
    },
};
exports.StarIcon = forwardRef_1.forwardRef('StarIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
